<template>
    <veui-button :ui="ui" :loading="loading" @click="tap">{{text}}</veui-button>
</template>

<script>
import {Button} from 'veui';
export default {
    components: {
        'veui-button': Button
    },
    props: {
        ui: {
            'type': String,
            'default': 'primary'
        },
        loading: {
            'type': Boolean,
            'default': false
        },
        text: {
            'type': String,
            'default': ''
        }
    },
    methods: {
        tap(e) {
            this.$emit('tapClick', e);
        }
    }
};
</script>
